import { useMemo, useRef } from 'react';

export function useMpdRefreshTimer() {
  const refreshTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const calculateNextRefreshTime = (validUntilSeconds: number) => {
    const delta = validUntilSeconds * 1000 - Date.now();

    // Set timer to 1 minute earlier
    return delta - 60_000;
  };

  /**
   * Clear timeout for presigned MPD refresh
   */
  const clear = () => {
    if (refreshTimeoutRef.current) {
      clearTimeout(refreshTimeoutRef.current);
      refreshTimeoutRef.current = null;
    }
  };

  /**
   * Set timer for callback
   * @param callback A function to run after N milliseconds
   * @param validUntilSeconds UNIX epoch timestamp
   */
  const schedule = (callback: () => void, validUntilSeconds: number) => {
    const timeout = calculateNextRefreshTime(validUntilSeconds);

    // window.__NEXT_MPD_REFRESH_DATETIME__ = new Date(
    //   Date.now() + timeout
    // ).toISOString();

    refreshTimeoutRef.current = setTimeout(callback, timeout);
  };

  return useMemo(() => ({ schedule, clear }), []);
}
